import { apiRequest } from '@/utils/request'

// 添加授权申请
export function addDelegate(data) {
  return apiRequest({
    url: '/DelegateApplication/Add',
    method: 'post',
    data: data
  })
}

// 获取授权列表
export function getDelegateList(queryParams) {
  return apiRequest({
    url: 'DelegateApplication/GetList',
    method: 'get',
    params: queryParams
  })
}

// 获取授权列表
export function getIdCardIs(queryParams) {
  return apiRequest({
    url: 'DelegateApplication/GetIdCardIs',
    method: 'get',
    params: queryParams
  })
}

// 上传案卷附件
export function uploadCaseAttach(formData) {
  return apiRequest({
    url: '/DelegateApplication/UploadIdCard',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

// 上传查询下载pdf
export function UploadCxxz(formData) {
  return apiRequest({
    url: '/DelegateApplication/UploadCxxz',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

// 添加服务评价
export function addServiceEvaluation(data) {
  return apiRequest({
    url: '/ServiceEvaluation/Add',
    method: 'post',
    data: data
  })
}
